module.exports = __webpack_public_path__ + "img/profile_docsign.6493b586.png";